import Vue from 'vue'
import VueI18n from 'vue-i18n'

import Storage from '@/helpers/storage'

import { configuration } from '../configuration'

import importEn from '@/locales/en'

Vue.use(VueI18n)


const backwardLanguage = {
    'en-US': 'en',
    'fr-FR': 'fr',
    'de-DE': 'de',
    'it-IT': 'it',
    'pl-PL': 'pl',
    'es-ES': 'es',
    'pt-PT': 'pt',
    'nl-NL': 'nl'
}


function updateLang() {

    let urlLang = minify(window.location.pathname.split('/')[1])

    urlLang = configuration.languages.indexOf(urlLang) > -1 ? urlLang : ''

    const startLang =  urlLang || Storage.getItem('lang') || (window.navigator.userLanguage || window.navigator.language).substring(0, 2) || configuration.defaultLanguage

    const goodLang = configuration.languages.indexOf(startLang) > -1 ? startLang : configuration.defaultLanguage

    Storage.setItem('lang', goodLang)

    return goodLang

}


function getConfigs () {

    const lang = updateLang()

    const messages = { 'en': importEn }
    const locale =  lang

    return {
        messages,
        locale,
        fallbackLocale: configuration.defaultLanguage
    }
}

function minify (lang = '') {

    let minLang = ''

    if(backwardLanguage[lang]) {

        minLang = backwardLanguage[lang]

    } else {

        minLang = lang
    }

    return minLang

}

export default new VueI18n(getConfigs())
